<template>
  <div>
    <Card
      v-if="socialMediaType === 'instagram'"
      class="social-media-card-posts"
      @click="handleRedirect(media.permalink)"
    >
      <template #title>
        <div class="social-media-card-header">
          <div>
            <i class="pi pi-instagram" style="font-size: 1rem" />
            <span class="social-media-card-header-title">Via Instagram</span>
          </div>
        </div>
        <div class="social-media-card-container-title">
          <img
            :src="media.media_url"
            alt="imagem da hashtag"
            v-if="media.media_type !== 'VIDEO'"
            class="social-media-card-title-avatar"
            @click="handleRedirect(media.permalink)"
          />
          <video controls v-if="media.media_type === 'VIDEO'">
            <source
              :src="media.media_url"
              type="video/mp4"
              class="social-media-card-title-avatar"
            />
          </video>
        </div>
      </template>
      <template #content>
        <span class="social-media-card-caption" @click="handleRedirect(media.permalink)">
          {{ media.caption }}
        </span>
      </template>
      <template #footer>
        <div class="social-media-card-footer-container-stats">
          <div class="social-media-card-footer-stats">
            <i class="pi pi-clock" style="font-size: 1rem" />
            <span>{{ convertTimestamp(media.publication_date) }}</span>
          </div>
          <div class="social-media-card-footer-stats">
            <i class="pi pi-comments" style="font-size: 1rem" />
            <span>{{ media.comments_count }}</span>
          </div>
          <div class="social-media-card-footer-stats">
            <i class="pi pi-thumbs-up" style="font-size: 1rem" />
            <span>{{ media.like_count }}</span>
          </div>
        </div>
      </template>
    </Card>
    <Card
      v-if="socialMediaType === 'tiktok'"
      class="social-media-card-posts"
      @click="handleRedirect(media.url)"
    >
      <template #title>
        <div class="social-media-card-header">
          <div>
            <i class="fa-brands fa-tiktok" style="font-size: 1rem" />
            <span class="social-media-card-header-title">Via Tiktok</span>
          </div>
        </div>
        <div class="social-media-card-container-title">
          <img
            :src="media.preview_image"
            alt="imagem da hashtag"
            class="social-media-card-title-avatar"
            @click="handleRedirect(media.url)"
          />
        </div>
      </template>
      <template #content>
        <span class="social-media-card-caption" @click="handleRedirect(media.url)">
          {{ media.description }}
        </span>
      </template>
      <template #footer>
        <div class="social-media-card-footer-container-stats">
          <div class="social-media-card-footer-stats">
            <i class="pi pi-clock" style="font-size: 1rem" />
            <span>{{ convertTimestamp(media.create_time) }}</span>
          </div>
          <div class="social-media-card-footer-stats">
            <i class="pi pi-comments" style="font-size: 1rem" />
            <span>{{ media.comment_count }}</span>
          </div>
          <div class="social-media-card-footer-stats">
            <i class="pi pi-thumbs-up" style="font-size: 1rem" />
            <span>{{ media.digg_count }}</span>
          </div>
        </div>
      </template>
    </Card>
  </div>
</template>

<script>
import Card from 'primevue/card'
import axios from 'axios'
import moment from 'moment'
moment.locale('pt-br')

export default {
  components: {
    Card,
  },
  props: {
    socialMediaType: String,
    media: Object,
    medias: Array,
  },
  data() {
    return {
      localMedias: [...this.medias],
    }
  },
  watch: {
    medias(newMedias) {
      this.localMedias = [...newMedias]
    },
  },
  methods: {
    convertTimestamp(date) {
      return moment(date).format('DD/MM/YYYY HH:MM')
    },
    handleRedirect(permalink) {
      window.open(permalink)
    },
    deletePost(permalink) {
      if (confirm('Tem certeza que deseja excluir esse post?')) {
        try {
          console.log(permalink)
          const response = axios.post(`/api/social-media/post/delete`, {
            permalink,
          })
          const updatedMedias = this.medias.filter((media) => media.permalink !== permalink)
          this.$emit('update:medias', updatedMedias)
        } catch (error) {}
      }
    },
  },
}
</script>

<style lang="scss" src="./styles.scss"></style>
